import React from 'react';

import styled from 'styled-components';

export const TAG_TYPE = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

const StyledTag = styled.div`
  ${({ type }) =>
    type === TAG_TYPE.SUCCESS &&
    `
    color: #2c6424;
    background: #d0ecc9;
  `}
  ${({ type }) =>
    type === TAG_TYPE.WARNING &&
    `
    color: #8A670F;
    background: #FFEEBF;
  `}
  ${({ type }) =>
    type === TAG_TYPE.ERROR &&
    `
    color: #7D150F;
    background: #f9c3bf;
  `}
  letter-spacing: 0.32px;
  border-radius: 4px;
  padding: 6.5px 12px 5.5px 12px;
  font-weight: 600;
  min-width: 80px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Tag = ({ children, type = TAG_TYPE.SUCCESS }) => (
  <StyledTag type={type}>{children}</StyledTag>
);

export default Tag;
